<template>
     <button class="btn btn-outline-success btn-sm rounded-0" @click="modal = !modal">
        <img src="../../../assets/pen-to-square.svg" width="15" >
    </button>
    <div v-if="modal" class="modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Editar</h5>
                <button @click="modal = !modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- <pre>
                    {{v_nics}}
                </pre> -->
                <div class="form-floating mb-3">
                    <input v-model="nic.title" type="text" class="form-control">
                    <label>Título</label>
                </div>
                <div class="form-floating mb-3">
                    <textarea style="height: 150px" v-model="nic.description" type="text" class="form-control"></textarea>
                    <label>Descripción</label>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <input type="radio" id="uno" value="es" v-model="nic.lang" class="mx-2">
                            <label for="uno">ES</label>
                            <br>
                            <input type="radio" id="Dos" value="en" v-model="nic.lang" class="mx-2">
                            <label for="Dos">EN</label>
                        </div>
                        <div class="col">
                            <label for="">Habilitado:</label>
                            <span class="form-switch">
                                <input 
                                class="form-check-input"
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="nic.enabled" 
                                >
                            </span>
                        </div>
                    </div>
                </div>
                
                
            </div>
            <div class="modal-footer">
                <button @click="modal = !modal" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button @click="save_nic" type="button" class="btn btn-primary">Guardar cambios</button>
            </div>
            </div>
        </div>
    </div>

</template>
<script>
    import axios from 'axios'
    import { useToast } from 'vue-toastification'
    import { ref,onUpdated, computed } from 'vue'
    import { useStore } from 'vuex'
    
    

    export default {
        name:"nicEdit",
        props:['nic_props'],
        setup(props){
            const store = useStore()
            const toast = useToast()
            const modal = ref(false)
            const v_user = computed(()=>store.state.login.v_user)
            const nic = ref({
                title:null,
                description:null,
                enabled:null,
                lang:null,
            })

            const save_nic = () => {
                console.log('test');

                let config = {
                        headers: {
                        'Authorization': 'Bearer ' + v_user.value.accessToken,
                        'Accept':'application/json'
                        }
                    }        
                axios.put(store.state.v_url_global+'/nics/'+props.nic_props.id,nic.value,config)
                .then(()=>{

                    toast.success('actualizado')
                    store.dispatch('nic/v_actions_nics')

                })
                .catch(()=>console.log('bad consult'))


            }
            
            onUpdated(()=>{
                nic.value = props.nic_props
            })

            return{
                save_nic,
                nic,
                modal,
            }
        }
    }

</script>